// extracted by mini-css-extract-plugin
export default {"multiSearch":"a0yvwLE87ClKwWsLUe58"};